import type { KyInstance } from "ky";

import { getLeaderboardTimeframe } from "./getLeaderboardTimeframe";

interface TotalCallCountResponse {
    callCount: number;
}

export const getTotalCallCount = async (client: KyInstance): Promise<TotalCallCountResponse> => {
    const { start, end } = getLeaderboardTimeframe();

    return await client.get(`v1/metrics/calls?start=${start}&end=${end}`, { retry: 0 }).json<TotalCallCountResponse>();
};
